module.exports = __webpack_public_path__ + "img/title12.2c0b09a3.png";